define('SliderPanel',[
    'jquery',
    'slick',
    'Swiper',
    'ANSI/Utility/Dimensions',
    'eventManager',
    'ANSI/Utility/SitecoreUtils',
    'matchHeight',
    'promise-polyfill',
], function ($, slick, Swiper, dimensions, eventManager, sitecoreUtils) {
    'use strict';
    var sliderPanel = {
        init: function () {
            sliderPanel.overviewSlider();
            sliderPanel.basicCardSlider();
            sliderPanel.customEventSlider();
            eventManager.subscribe('ModulesLoadedEvent', function () {
                sliderPanel.stepSlider();
                sliderPanel.mobileSlider();
                sliderPanel.tabSliderHome();
            });
        },
        tabSliderHome: function () {
            if ($('.slider-panel').length) {
                var sliderPanelHome = $(
                    '.slider-panel .score-right .slider-panel'
                );

                var settingsHome = {
                    draggable: true,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    accessibility: true,
                    centerMode: true,
                    arrows: true,
                    variableWidth: true,
                    touchThreshold: 10,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 2,
                                arrows: true,
                                mobileFirst: true,
                                centerMode: false,
                            },
                        },
                        {
                            breakpoint: 1260,
                            settings: {
                                slidesToShow: 2,
                                arrows: true,
                                mobileFirst: true,
                                centerMode: false,
                            },
                        },
                        {
                            breakpoint: 1430,
                            settings: {
                                slidesToShow: 3,
                                arrows: true,
                                mobileFirst: true,
                                centerMode: false,
                            },
                        },
                        {
                            breakpoint: 1920,
                            settings: {
                                slidesToShow: 3,
                                arrows: true,
                                mobileFirst: true,
                                centerMode: false,
                            },
                        },
                        {
                            breakpoint: 2448,
                            settings: {
                                slidesToShow: 3,
                                mobileFirst: true,
                                centerMode: false,
                            },
                        },
                        {
                            breakpoint: 2972,
                            settings: {
                                slidesToShow: 3,
                                mobileFirst: true,
                                centerMode: false,
                            },
                        },
                        {
                            breakpoint: 3496,
                            settings: {
                                slidesToShow: 3,
                                mobileFirst: true,
                                centerMode: false,
                            },
                        },
                    ],
                };

                sliderPanelHome.slick(settingsHome);
            }
        },
        overviewSlider: function () {
            if (
                $('.swiper-container.ansi-image-card-slider').length &&
                dimensions.width < 960
            ) {
                $('.ansi-image-card-slider .swiper-slide').matchHeight({
                    byRow: false,
                });
                $('.swiper-container.ansi-image-card-slider').append(
                    '<div class="swiper-pagination"></div>'
                );
                var swiper = new Swiper(
                    '.swiper-container.ansi-image-card-slider',
                    {
                        direction: 'horizontal',
                        centeredSlides: true,
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true,
                        },
                    }
                );
            }
        },
        customEventSlider: function () {
            //this is for image grid on the bottom of the custom events page
            var eventSlider = $('.custom-event .grid-5');
            if (dimensions.width < 600) {
                var customEventSliderSettings = {
                    draggable: true,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    accessibility: true,
                    centerMode: true,
                    arrows: true,
                    variableWidth: true,
                    touchThreshold: 10,
                };
                eventSlider.slick(customEventSliderSettings);
            }
        },
        stepSlider: function () {
            if ($('.ansi-step-slider.swiper-container').length) {
                $('.ansi-step-slider .swiper-slide').matchHeight({
                    byRow: false,
                });
                $('.ansi-step-slider.swiper-container')
                    .append('<div class="swiper-pagination"></div>')
                    .append('<div class="swiper-button-next"></div>')
                    .append('<div class="swiper-button-prev"></div>');
                var swiper = new Swiper('.ansi-step-slider.swiper-container', {
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'fraction',
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });

                $(document).on(
                    'shown.bs.tab',
                    'a[data-toggle="tab"]',
                    function (e) {
                        var paneTarget = $(e.target).attr('href');
                        var $thePane = $('.tab-pane' + paneTarget);
                        var paneIndex = $thePane.index();
                        if (
                            $thePane.find('.swiper-container').length > 0 &&
                            0 === $thePane.find('.swiper-slide-active').length
                        ) {
                            swiper[paneIndex].update();
                        }
                    }
                );
            }
        },
        mobileSlider: function () {
            if ($('.mobile-slider').length && dimensions.width < 992) {
                var mobileSlide = $('.mobile-slider');
                var sliderSettings = {
                    draggable: true,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    accessibility: true,
                    centerMode: true,
                    arrows: true,
                    variableWidth: true,
                    touchThreshold: 10,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 575,
                            settings: { slidesToShow: 2 },
                        },
                    ],
                };
                mobileSlide.slick(sliderSettings);
            }
        },
        basicCardSlider: function () {
            if (
                $('.swiper-container.ansi-basic-card-slider').length &&
                dimensions.width < 992
            ) {
                $('.swiper-container.ansi-basic-card-slider')
                    .append('<div class="swiper-button-next"></div>')
                    .append('<div class="swiper-button-prev"></div>');
                var swiper = new Swiper(
                    '.swiper-container.ansi-basic-card-slider',
                    {
                        centeredSlides: true,
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                        freeMode: true,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                    }
                );
            }
        },
    };
    if (!sitecoreUtils.prototype.isEditing())
        Promise.resolve().then(sliderPanel.init);
});

